// *********************************
// CoolGames Builder JavaScript file
// *********************************
import { tbEase } from "../engine/tbEase";
import { tgfAudio } from "../framework/tgfAudio";
import { tgfFunctions } from "../framework/tgfFunctions";
import { PowerUpSettings, PigSettings } from "../settings/Settings";
import { SoundManager } from "../settings/SoundManager";
import { s_shield01, s_indicator_target } from "./AssetDefinitions/ImageDefinitions";
import { s_smokePuff, s_smokePlume, powerup_animations } from "./AssetDefinitions/SpineDefinitions";
import { PhysicsObject } from "./PhysicsObject";
import { getContainerForLayer, Layer } from "./SceneController";
import { SpineEffect } from "./SpineEffect";
import { playController } from "./gameController";
export function PigObject(def, uid, x, y, angle, container) {
    "use strict";
    PigObject.uber.constructor.call(this, def, uid, x, y, angle, container);
    this.isPig = true;
    this.shield = 0;
    this.shieldImage = s_shield01.clone();
    this.shieldImage.setScale(PowerUpSettings.shieldSettings.scale, PowerUpSettings.shieldSettings.scale);
    this.shieldImage.setAlpha(0);
    this.image.addChild(this.shieldImage);
    this.damaged = false;
    this.damageExtension = "_damaged";
    this.firstDamage = false;
    this.mirror = 1;
    this.currentlyFlipped = false;
    this.currentState = "";
    this.isMoving = false;
    this.animationIdleDelay = 0;
    this.animationScaredDelay = 0;
    this.animationScaredJumpDelay = 0;
    this.swapSpineEffect = null;
    // add target indicator 
    this.indicatorActive = false;
    this.indicatorFadeTime = 500;
    this.indicatorFadeTimer = 0;
    // add target indicator 
    this.indicatorTargetBaseScale = PowerUpSettings.shieldSettings.scale * 1.1;
    this.indicatorTargetImage = s_indicator_target.clone();
    this.indicatorTargetImage.setScale(this.indicatorTargetBaseScale, this.indicatorTargetBaseScale);
    this.indicatorTargetImage.setAlpha(0);
    this.indicatorTargetImage.setPosition(0, 0);
    this.image.addChild(this.indicatorTargetImage);
    if (Math.random() < 0.5)
        this.mirror = -1;
    this.totalIdleWeight = 0;
    this.idleWeightRanges = [];
    for (var a = 0; a < PigSettings.idleAnimations.length; a++) {
        this.idleWeightRanges[a] = this.totalIdleWeight;
        this.totalIdleWeight += PigSettings.idleAnimations[a].weight;
    }
    for (var a = 0; a < PigSettings.idleAnimations.length; a++) {
        this.idleWeightRanges[a] /= this.totalIdleWeight;
    }
    this.soundStates = SoundManager.PIG_STATE;
    this.animationState(PigObject.STATE.IDLE, false);
}
;
tgfFunctions.inherit(PigObject, PhysicsObject);
PigObject.STATE = {
    IDLE: "pig_idle",
    SCARED: "pig_scared",
    SCARED_JUMP: "pig_scared_jump",
    CHUCKLING: "pig_chuckling",
    LAUGHING: "pig_laughing",
    SLEEPING: "pig_sleeping"
};
PigObject.SIZE = {
    SMALL: 'small',
    MEDIUM: 'medium',
    BIG: 'big'
};
PigObject.prototype.setSkin = function (isAlly) {
    'use strict';
    this.isAlly = isAlly;
    this.isFirstPig = (this.isAlly && playController.isInitiatingPlayer) || (!this.isAlly && !playController.isInitiatingPlayer);
    this.smokePuffName = this.isAlly ? "s_smoke_puff_pig_main" : "s_smoke_puff_pig";
    this.smokePlumeName = this.isAlly ? "smoke_plum_pig_main" : "smoke_plum_pig";
    this.skin = this.isAlly ? "skin_0000_blue" : "skin_0000_pink";
    this.image.setSkin(this.skin);
};
PigObject.prototype.getSize = function () {
    'use strict';
    if (this.body.physicsObj.definitionName.includes('SMALL')) {
        return PigObject.SIZE.SMALL;
    }
    else if (this.body.physicsObj.definitionName.includes('MEDIUM')) {
        return PigObject.SIZE.MEDIUM;
    }
    else {
        return PigObject.SIZE.BIG;
    }
};
PigObject.prototype.setPigState = function (newState) {
    this.health = newState.health;
    this.damaged = newState.damaged;
    if (this.isAlly !== newState.isAlly) {
        this.definitionName = newState.definition;
        this.setSkin(newState.isAlly);
    }
    this.activateShield(newState.shield);
    //TODO: add this to the builder
    this.image.animation.skeleton['setSlotsToSetupPose']();
};
PigObject.prototype.getPigState = function () {
    return {
        shield: this.shield,
        health: this.health,
        isAlly: this.isAlly,
        damaged: this.damaged,
        definition: this.definitionName
    };
};
PigObject.prototype.randomIdleAnimation = function () {
    var i = Math.random();
    for (var a = this.idleWeightRanges.length - 1; a > -1; a--) {
        if (i > this.idleWeightRanges[a])
            return PigSettings.idleAnimations[a].name;
    }
};
PigObject.prototype.applyDamage = function (damage) {
    if (playController.gameType == "practice" && this.isAlly) {
        damage = damage * 0.3;
    }
    if (this.shield != 0) {
        if (this.shield <= damage) {
            damage -= this.shield;
            this.shield = 0;
            this.shieldImage.setAlpha(0);
        }
        else {
            this.shield -= damage;
            return;
        }
    }
    PigObject.uber.applyDamage.call(this, damage);
    if (this.firstContact && damage > 10) {
        var capDamage = Math.max(10, Math.min(damage, 25));
        new SpineEffect(this.x, this.y, this.material.impact.spine, this.material.impact.name, getContainerForLayer(Layer.smokePuff), (capDamage / 20));
    }
};
PigObject.prototype.activateShield = function (health) {
    this.shield = health;
    this.shieldImage.setAlpha(this.shield);
};
PigObject.prototype.getShield = function () {
    'use strict';
    return Math.ceil(this.shield);
};
PigObject.prototype.showTargetIndicator = function () {
    "use strict";
    this.indicatorActive = true;
    if (this.indicatorFadeTimer < 0) {
        this.indicatorFadeTimer = 0;
    }
};
PigObject.prototype.hideTargetIndicator = function () {
    "use strict";
    this.indicatorActive = false;
    if (this.indicatorFadeTimer > this.indicatorFadeTime) {
        this.indicatorFadeTimer = this.indicatorFadeTime;
    }
};
PigObject.prototype.handleTargetIndicators = function (timePassed) {
    "use strict";
    if (this.indicatorTargetImage) {
        // fade in based on their alpha
        if (this.indicatorFadeTimer > this.indicatorFadeTime) {
            this.indicatorFadeTimer = this.indicatorFadeTime;
        }
        else if (this.indicatorFadeTimer < 0) {
            this.indicatorFadeTimer = 0;
        }
        //(time, begin, change, duration)
        var newAlpha = tbEase.easeInOutQuadratic(this.indicatorFadeTimer, 0, 1, this.indicatorFadeTime);
        if (newAlpha < 0)
            newAlpha = 0;
        if (newAlpha > 1)
            newAlpha = 1;
        this.indicatorTargetImage.setAlpha(newAlpha);
        if (this.indicatorActive) {
            this.indicatorFadeTimer += timePassed;
            this.indicatorTargetImage.setRotation(this.indicatorTargetImage.rotation + 0.015);
        }
        else {
            this.indicatorFadeTimer -= timePassed;
        }
    }
};
PigObject.prototype.step = function (timePassed) {
    "use strict";
    var damagePercentage = this.health / this.maxHealth;
    this.handleTargetIndicators(timePassed);
    if (damagePercentage < 0.9) {
        this.damaged = true;
        if (!this.firstDamage) {
            this.animationState(this.currentState);
            this.firstDamage = true;
        }
    }
    if (this._selectedPigEffect) {
        this._selectedPigEffect.setPosition(this.x, this.y);
    }
    // if the body exists and the movement is within threshold
    if (this.body && PigSettings && ((this.velocity.x < -PigSettings.animateWhileMovingThreshold || this.velocity.x > PigSettings.animateWhileMovingThreshold) ||
        (this.velocity.y < -PigSettings.animateWhileMovingThreshold || this.velocity.y > PigSettings.animateWhileMovingThreshold) ||
        (this.angular_velocity > PigSettings.animateWhileMovingThreshold || this.angular_velocity < -PigSettings.animateWhileMovingThreshold))) {
        if (this.currentState != PigObject.STATE.IDLE) {
            this.animationState(PigObject.STATE.IDLE);
        }
        this.isMoving = true;
    }
    else
        this.isMoving = false;
    if (this && this.image) {
        if (this.animationIdleDelay > 1) {
            this.animationIdleDelay--;
        }
        else if (this.animationIdleDelay == 1) {
            if (this.nextState) {
                this.animationState(this.nextState);
                this.nextState = null;
            }
            else {
                this.animationState(PigObject.STATE.IDLE);
            }
            this.animationIdleDelay--;
        }
        if (this.animationScaredDelay > 1) {
            this.animationScaredDelay--;
        }
        else if (this.animationScaredDelay == 1) {
            this.animationState(PigObject.STATE.SCARED);
            this.animationScaredDelay--;
        }
        if (this.animationScaredJumpDelay > 1) {
            this.animationScaredJumpDelay--;
        }
        else if (this.animationScaredJumpDelay == 1) {
            if (this.nextState) {
                this.animationState(this.nextState);
                this.nextState = null;
            }
            else {
                this.animationState(PigObject.STATE.SCARED);
            }
            this.animationScaredJumpDelay--;
        }
        if (this.currentlyFlipped && this.mirror == 1) {
            this.image.flip();
            this.currentlyFlipped = false;
        }
        if (!this.currentlyFlipped && this.mirror == -1) {
            this.image.flip();
            this.currentlyFlipped = true;
        }
    }
    if (this.swapSpineEffect) {
        this.swapSpineEffect.x = this.x;
        this.swapSpineEffect.y = this.y + PowerUpSettings.pigSwapSettings.animationYOffset;
    }
};
PigObject.prototype.finalEffect = function () {
    "use strict";
    new SpineEffect(this.x, this.y, s_smokePuff, this.smokePuffName, getContainerForLayer(Layer.smokePuff));
    new SpineEffect(this.x, this.y, s_smokePlume, this.smokePlumeName, getContainerForLayer(Layer.smokePuff));
    this.playSound(this.soundStates.DEATH, this.definition.sounds);
};
PigObject.prototype.swapEffect = function () {
    "use strict";
    var animationScale = 0;
    switch (this.getSize()) {
        case PigObject.SIZE.SMALL:
            animationScale = PowerUpSettings.pigSwapSettings.animationScaleSmall;
            break;
        case PigObject.SIZE.MEDIUM:
            animationScale = PowerUpSettings.pigSwapSettings.animationScaleMedium;
            break;
        case PigObject.SIZE.BIG:
            animationScale = PowerUpSettings.pigSwapSettings.animationScaleBig;
            break;
    }
    this.swapSpineEffect = new SpineEffect(this.x, this.y + PowerUpSettings.pigSwapSettings.animationYOffset, powerup_animations, "pigswap_animationgreen", getContainerForLayer(Layer.particle), animationScale, "alpha", function (self) {
        self.alphaEvents++;
        if (self.alphaEvents == 2) {
            var obj = playController.sceneController.findInSceneGraphByID(self.id)[0];
            if (obj) {
                obj.image.setAlpha(1);
                obj.invisible = false;
            }
        }
    }, this);
    this.alphaEvents = 0;
    this.image.setAlpha(0);
    this.invisible = true;
};
PigObject.prototype.animationState = function (state) {
    "use strict";
    var self = this;
    if (!this.image)
        return;
    if (this.currentAnimation === "pig_happy_jumping" || this.currentAnimation === "pig_scared_jump") {
        this.nextState = state;
        return;
    }
    // this.image.clearOnComplete();
    this.currentState = state;
    this.animationIdleDelay = 0;
    this.animationScaredDelay = 0;
    this.animationScaredJumpDelay = 0;
    switch (state) {
        case PigObject.STATE.IDLE:
            if (this.isMoving) {
                this.currentAnimation = "pig_scared";
            }
            else {
                if (this.angle > -0.45 && this.angle < 0.45) {
                    this.currentAnimation = this.randomIdleAnimation();
                }
                else {
                    this.currentAnimation = "pig_idle";
                }
            }
            var soundID;
            if (!SoundManager.mutedPigs) {
                switch (this.currentAnimation) {
                    case "pig_idle":
                        if (!this.soundCheck(this.currentAnimation)) {
                            soundID = SoundManager.playEffect(this.soundStates.IDLE, this.definition.sound);
                            SoundManager._pigSoundManager[this.currentAnimation] = soundID;
                        }
                        break;
                    case "pig_idle2":
                        break;
                    case "pig_chuckling":
                        if (!this.soundCheck(this.currentAnimation)) {
                            soundID = SoundManager.playEffect(this.soundStates.CHUCKLING, this.definition.sound);
                            SoundManager._pigSoundManager[this.currentAnimation] = soundID;
                        }
                        break;
                    case "pig_laughing":
                        if (!this.soundCheck(this.currentAnimation)) {
                            soundID = SoundManager.playEffect(this.soundStates.LAUGHING, this.definition.sound);
                            SoundManager._pigSoundManager[this.currentAnimation] = soundID;
                        }
                        break;
                    case "pig_happy_jumping":
                        // if(!this.soundCheck(this.currentAnimation)){
                        // soundID = SoundManager.playEffect(this.soundStates.LAUGHING, this.definition.sound);
                        //     SoundManager._pigSoundManager[this.currentAnimation] = soundID;
                        // }
                        break;
                    case "pig_sleeping":
                        if (!this.soundCheck(this.currentAnimation)) {
                            soundID = SoundManager.playSequence(this.soundStates.SLEEPING, this.definition.sound, 3); //SoundManager.playEffect(this.soundStates.SLEEPING, this.definition.sound[0]);
                            SoundManager._pigSoundManager[this.currentAnimation] = soundID;
                        }
                        break;
                }
            }
            this.currentAnimation = this.postfixAnimation(this.currentAnimation);
            this.image.setAnimation(this.currentAnimation, false);
            this.image.setOnComplete(function () {
                if (!self.image)
                    return;
                self.animationIdleDelay = 1; // + Math.floor(Math.random() * 5);
                // self.image.clearOnComplete();
                self.currentAnimation = null;
            });
            break;
        case PigObject.STATE.SCARED_JUMP:
            this.currentAnimation = this.postfixAnimation(PigSettings["scaredAnimation"][0]);
            this.image.setAnimation(this.currentAnimation, false);
            this.image.setOnComplete(function () {
                if (!self.image)
                    return;
                self.animationScaredJumpDelay = 1;
                // self.animationState(PigObject.STATE.SCARED);
                // self.image.clearOnComplete();
                self.currentAnimation = null;
            });
            break;
        case PigObject.STATE.SCARED:
            this.currentAnimation = this.postfixAnimation(PigSettings["scaredAnimation"][1]);
            if (!this.soundCheck(PigObject.STATE.SCARED)) {
                var soundID = SoundManager.playEffect(this.soundStates.SCARED, this.definition.sound);
                SoundManager._pigSoundManager[PigObject.STATE.SCARED] = soundID;
            }
            this.image.setAnimation(this.currentAnimation, false);
            this.image.setOnComplete(function () {
                if (!self.image)
                    return;
                self.animationScaredDelay = 1;
                // self.animationState(PigObject.STATE.SCARED);
                // self.image.clearOnComplete();
                self.currentAnimation = null;
            });
            break;
    }
};
PigObject.prototype.soundCheck = function (tag) {
    "use strict";
    var id;
    if (!SoundManager._pigSoundManager[tag]) {
        return false;
    }
    else {
        id = SoundManager._pigSoundManager[tag];
    }
    var canPlay = tgfAudio.isActive(id);
    if (SoundManager._soundTimer > 0) {
        return true;
    }
    else {
        SoundManager.reset();
    }
    return canPlay;
};
PigObject.prototype.postfixAnimation = function (animation) {
    return animation + (this.damaged ? this.damageExtension : "");
};
// DEPRECATED i think -Sam
PigObject.prototype.isMoving = function () {
    "use strict";
    if (!this.body) {
        return false;
    }
    var dx = this.velocity.x;
    var dy = this.velocity.y;
    if (Math.abs(this.angular_velocity) + Math.sqrt(dx * dx + dy * dy) > 0.1) {
        if (this.currentState != PigObject.STATE.IDLE) {
            this.animationState(PigObject.STATE.IDLE);
        }
    }
};
